var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "55.000000pt",
    height: "70.000000pt",
    viewBox: "0 0 55.000000 70.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,70.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 675 c-67 -66 19 -184 103 -141 53 27 58 91 13 137 -38 37 -82 39 -116 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 679 c-21 -12 -23 -48 -5 -74 10 -13 21 -16 40 -11 33 8 43 40 23 71 -18 27 -31 30 -58 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 676 c-17 -20 -10 -67 12 -80 15 -9 22 -7 38 13 23 28 24 45 3 65 -19 20 -38 20 -53 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 638 c-36 -36 11 -96 49 -62 31 28 18 74 -21 74 -9 0 -21 -5 -28 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 570 c-75 -18 -125 -84 -117 -155 6 -47 43 -85 84 -85 28 0 67 -22 89 -50 20 -25 15 -58 -22 -129 -38 -73 -42 -97 -22 -125 19 -26 87 -32 131 -11 109 52 170 350 96 470 -38 62 -159 105 -239 85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 565 c-18 -22 -8 -50 19 -50 28 0 47 25 38 49 -8 20 -40 21 -57 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanFoot);
export default __webpack_public_path__ + "static/media/human_foot.477cf439143a01fe074591660ecdf04e.svg";
export { ForwardRef as ReactComponent };